import styled from 'styled-components';

import { blue } from 'utils/style/colors';

interface IMenuItemProps {
  isHighlighted: boolean;
}

export const MenuItem = styled('li')<IMenuItemProps>`
  flex: none;
  width: 100%;
  color: #7c7e80;
  cursor: pointer;
  padding: 0.5rem 1rem;
  min-height: 2.5rem;
  transition: all 0.2s ease-out;
  font-weight: 400;
  line-height: 1.5rem;
  border-bottom: 1px solid #e8e8e8;
  background-color: ${(props) => (props.isHighlighted ? '#EEFCF9' : 'white')};
`;

export const menuStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '4px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  position: 'absolute',
  overflow: 'auto',
  maxHeight:
    document && document.documentElement
      ? (document.documentElement.clientHeight * 2) / 3
      : undefined,
  background: 'rgba(255, 255, 255, 0.9)',
  fontSize: '90%',
  marginTop: '2px',
  zIndex: 999,
  width: '100%',
};

export const NoItem = styled(MenuItem)`
  text-align: center;
  pointer-events: none;
  color: ${blue};
`;
